import { render, staticRenderFns } from "./AdvancedAudit.vue?vue&type=template&id=5672fb66"
import script from "./AdvancedAudit.vue?vue&type=script&lang=js"
export * from "./AdvancedAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports